import type { SystemStyleObject } from "@ui/types";

export const wrapperStyle: SystemStyleObject = {
    "&&&&": {
        position: ["absolute"],
        top: [3],
        left: [3],
        zIndex: 3,
        px: 5,
        py: 3,
        bg: "white",
        minW: [200],
        w: "fit-content",
        h: [50],
    },
};

export const textStyle: SystemStyleObject = {
    fontWeight: "bold",
    fontSize: "desktopBodyB2",
};
